/**
 * Created by nicolas.looschen@pikobytes.de on 07.05.2025.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import type { i18n } from 'i18next';

function lowerCase(value: string, lng: string): string {
    return value.toLowerCase();
}

export function addCustomFormats(i18NextInstance: i18n) {
    i18NextInstance.services.formatter?.add('lowerCase', lowerCase);
}
